import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Mail, MapPin, Phone } from "lucide-react";

const LOGO_URL = "https://customer-assets-eiarnc6j.emergentagent.net/job_nomad-wheels-8/artifacts/pqjvkrx0_ChatGPT%20Image%20Sep%2014%2C%202026%20at%2010_25_01%20PM.png";

export default function Footer() {
  return (
    <footer className="bg-[#1F4D3A] text-[#F5F0E8] pt-20 pb-8 mt-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-1">
          <div className="bg-[#F7F3EA] rounded-xl inline-block p-3 mb-4">
            <img src={LOGO_URL} alt="On Wheels" className="logo-nobg h-14 w-auto object-contain" />
          </div>
          <p className="text-sm text-[#D9CDB0] leading-relaxed">
            Where every journey becomes an adventure — curated small-group road trips across the wild, hospitable corners of India.
          </p>
          <div className="flex gap-3 mt-6">
            {[
              { Icon: Instagram, name: 'instagram', href: 'https://www.instagram.com/on_wheels.co' },
              { Icon: Facebook, name: 'facebook', href: '#' },
              { Icon: Youtube, name: 'youtube', href: '#' }
            ].map(({ Icon, name, href }) => (
              <a
                key={name}
                href={href}
                target={href.startsWith('http') ? '_blank' : undefined}
                rel={href.startsWith('http') ? 'noopener noreferrer' : undefined}
                aria-label={name}
                data-testid={`footer-social-${name}`}
                className="w-9 h-9 rounded-full bg-[#2D6B4F] hover:bg-[#C9A961] hover:text-[#1F4D3A] flex items-center justify-center transition-colors"
              >
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="font-serif text-lg font-semibold mb-4 text-[#C9A961]">Explore</h4>
          <ul className="space-y-2 text-sm text-[#D9CDB0]">
            <li><Link to="/" className="hover:text-white transition-colors">Home</Link></li>
            <li><Link to="/tours" className="hover:text-white transition-colors">All Tours</Link></li>
            <li><Link to="/about" className="hover:text-white transition-colors">Our Story</Link></li>
            <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-serif text-lg font-semibold mb-4 text-[#C9A961]">Destinations</h4>
          <ul className="space-y-2 text-sm text-[#D9CDB0]">
            <li>Himachal & Spiti</li>
            <li>Leh Ladakh</li>
            <li>Meghalaya</li>
            <li>Kerala Backwaters</li>
            <li>Rajasthan</li>
          </ul>
        </div>

        <div>
          <h4 className="font-serif text-lg font-semibold mb-4 text-[#C9A961]">Reach us</h4>
          <ul className="space-y-3 text-sm text-[#D9CDB0]">
            <li className="flex items-start gap-3" data-testid="footer-address">
              <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" /> Bharath Nagar, Bengaluru
            </li>
            <li className="flex items-center gap-3" data-testid="footer-phone">
              <Phone className="w-4 h-4" />
              <a href="tel:+919606094060" className="hover:text-white transition-colors">+91 96060 94060</a>
            </li>
            <li className="flex items-center gap-3" data-testid="footer-email">
              <Mail className="w-4 h-4" />
              <a href="mailto:contact@onwheels.cc" className="hover:text-white transition-colors">contact@onwheels.cc</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 mt-14 pt-6 border-t border-[#2D6B4F] flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-[#A8B8A0]">
        <p>© {new Date().getFullYear()} On Wheels. All rights reserved.</p>
        <p>Where every journey becomes an adventure</p>
      </div>
    </footer>
  );
}
